export interface ImageInterface {
  url?: string;
  title?: string;
  alt?: string;
  deleted?: boolean;
}
